<template>
  <NuxtLink
    :to="buttonLink"
    class="font-inter flex transform select-none items-center justify-center gap-2 rounded border-2 border-gray-200 bg-transparent px-4 py-3 text-min text-primary shadow-sm hover:-translate-y-0.5 hover:text-main-secondary active:text-main-primary"
  >
    <span>
      <slot />
    </span>
  </NuxtLink>
</template>

<script>
export default {
  name: 'GhostButtonLink',

  props: {
    buttonLink: {
      type: String,
      default: '/',
    },
    defaultBgColors: {
      type: String,
      default: 'bg-transparent hover:text-main-secondary active:bg-transparent',
    },
  },
}
</script>
